import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-contents-main-header',
	templateUrl:'./WaPageContentsMainHeaderProPage.html',
	styles: [],
	styleUrls:['./WaPageContentsMainHeaderProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageContentsMainHeaderProPage
{
	mdContent_388 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageContentsMainHeader;
\`\`\``;
	mdContent_389 = `\`\`\`java
new WaPageContentsMainHeader<>()
\`\`\``;
}
